import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const SeasonTerrace = (props) => {
    const [sectionMarginTop, setSectionMarginTop] = useState('3rem');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
            let rowPaddingSeason = document.querySelector('.box-allseason').getBoundingClientRect().height;
            setSectionMarginTop((rowPaddingSeason + 80) + "px");
        }
    }, [notMobile]);

    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-allseason" id="Exteriors">
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Exteriors</h1></div>
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">All-season terrace</h2>
                                <img src="images/Infynito80/allseason-terrace/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-allseason">
                                    <h3 className="mb-3">Bow Area</h3>
                                    <p>The hallmark of the range is our iconic covered terrace, sheltered by an extension to the superstructure for protection in all weather conditions and total privacy.</p>
                                    <p>The All Season Terrace offers a stunning private experience year-round. You may choose between a lounge or a private bar, seamlessly connected to the kitchen through a hi-lo glass wall.</p>
                                    <p>This design ensures a luxurious and comfortable atmosphere, ideal for entertaining guests or enjoying intimate gatherings.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-allseason pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-allseason w-100" />
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}>
                            <div className="col-md-6 px-lg-5 mb-4 mb-0">
                                <h4 className="text-center text-white">Version 1</h4>
                                <img src="images/Infynito80/allseason-terrace/allseason-02.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-md-6 px-lg-5">
                                <h4 className="text-center text-white">Version 2</h4>
                                <img src="images/Infynito80/allseason-terrace/allseason-01.jpg" alt="" className="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid bkg-allseason" id="Exteriors">
                    <div className="header-section text-white text-center py-5"><h1 className="h1">Esterni</h1></div>
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">All-season terrace</h2>
                                <img src="images/Infynito80/allseason-terrace/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-allseason">
                                    <h3 className="mb-3">Ponte di Prua</h3>
                                    <p>La nostra iconica terrazza coperta offre protezione in tutte le condizioni atmosferiche, garantendo totale privacy.</p>
                                    <p>All-Season Terrace ti permette di goderti uno spazio privato straordinario tutto l'anno, con la possibilità di scegliere tra un salotto o un bar privato, collegati direttamente alla cucina tramite un'ampia finestratura a scomparsa.</p>
                                    <p>Questo design garantisce un'atmosfera lussuosa e confortevole, ideale per intrattenere ospiti o godersi una privacy totale.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-allseason pin-animation" />
                                <img src="images/Infynito80/main-deck.png" alt="" className="main-deck-allseason w-100" />
                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}>
                            <div className="col-md-6 px-lg-5 mb-4 mb-0">
                                <h4 className="text-center text-white">Versione 1</h4>
                                <img src="images/Infynito80/allseason-terrace/allseason-02.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-md-6 px-lg-5">
                                <h4 className="text-center text-white">Versione 2</h4>
                                <img src="images/Infynito80/allseason-terrace/allseason-01.jpg" alt="" className="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );

};

export default SeasonTerrace;